<template>
  <autocomplete :disabled="disabled" v-if="(staticItems && addresses) || !staticItems" ref="suggestions" v-model="searchQuery" :options="options" without-search-icon :onItemSelected="onSearchItemSelected" :onInputChange="onInputChange" :staticItems="(staticItems && addresses && addresses.length > 0) ? addresses : null" :required="required" autofocus>
    <template #item="props">
      <span class="name" v-show="props.item && props.item.plusCode">
        <small class="text-danger text-uppercase"><small>plus code</small></small>
        {{props.item.code}}
      </span>
      <span class="name" v-show="props.item && props.item.main_text">
        <font-awesome-icon class="text-secondary " icon="map-marker-alt" size="sm" />
        {{props.item.main_text + ', ' + props.item.secondary_text }}
      </span>
      <span class="name" v-show="props.item && props.item.external_id">
        <small class="text-danger text-uppercase"><small v-translate>Geofence</small></small>
        <geofence-title :geofence="props.item" />
      </span>
      <span class="name" v-show="props.item && props.item.coordinates">
        <small class="text-danger text-uppercase"><small v-translate>Coordinates</small></small>
        {{props.item.coords}}
      </span>
      <span v-if="props.item.reference">
        <font-awesome-icon class="text-secondary " icon="bookmark" size="sm" />
        <strong>{{props.item.reference}}</strong><br>
        {{props.item.place.formatted_address}}
      </span>
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  name: 'AllInOneGeoAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    preQuery: {
      type: String,
      default: ''
    },
    staticItems: {
      type: Boolean
    },
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.$gettext('Address, coords, geofence or plus code'),
        inputClass: 'form-control'
      },
      staticItemsArray: this.$store.getters.addresses,
      addresses: []
    }
  },
  created() {
    if (this.staticItems) {
      let staticItems = this.profile.company?.stores || []
      this.addresses = this.staticItemsArray = (staticItems.concat(JSON.parse(localStorage.getItem('savedAddresses'))) || this.$store.getters.addresses).filter(Boolean)
    }
    this.searchQuery = this.preQuery
  },
  methods: {
    onInputChange(query) {
      this.$emit('input', query)
      if (typeof query !== 'object') {
        query = query.trim()
        if (query.length < this.minCharacter && this.staticItems) {
          if (query.length > 0) {
            return this.addresses.filter((address) => {
              return ((address.reference && address.reference.toLowerCase().includes(query.toLowerCase())) ||
                (address.contact && address.contact.toLowerCase().includes(query.toLowerCase())) ||
                (address.place && address.place.formatted_address.toLowerCase().includes(query.toLowerCase())))
            })
          } else {
            return this.addresses
          }
        }
      } else {
        return this.addresses || null
      }
      if (query.length >= this.minCharacter) {
        const plusCodesRegexp = new RegExp(/(^|\s)([23456789CFGHJMPQRVWX]{4,6}\+[23456789CFGHJMPQRVWX]{2,3})(\W+\w+|\.)+(\s|\.|$)|(^|\s)([23456789C][23456789CFGHJMPQRV][23456789CFGHJMPQRVWX]{6}\+[23456789CFGHJMPQRVWX]{2,3})(\s|$)/i)
        const coordinatesRegexp = new RegExp(/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/)

        if (!plusCodesRegexp.test(query) && !coordinatesRegexp.test(query)) {
          return this.doExternalSearch(query)
        } else if (coordinatesRegexp.test(query)) {
          return [{coords: query, coordinates: true}]
        } else {
          return [{code: query, plusCode: true}]
        }
      }
    },
    async doExternalSearch(query) {
      if (query.length >= this.minCharacter) {
        let fetches = []
        // AC request
        fetches.push(this.$http.get(this.$appConfig.api.baseUrl + 'autocomplete?query=' + encodeURI(query.replace(/#/g, '%23 ')).replace(/\+/g, '%2B')))

        // Geofences request
        let params = {
          fields: 'external_id,name,reference_location,fence',
          limit: 16,
          sort: [
            {
              key: 'name',
              direction: 'asc'
            },
            {
              key: 'id',
              direction: 'asc'
            }
          ],
          filter_groups: [
            {
              or: true,
              filters: [
                ['reference_location', 'sw', query],
                ['name', 'ct', query],
                ['external_id', 'ct', query],
                ['geo_type.level', 'eq', '0']
              ]
            }
          ]
        }
        fetches.push(this.$http.get(this.$appConfig.api.baseUrl + 'geo-fences', {params}))

        let results = await Promise.all(fetches)
          .then(response => {
            return response[1].body.data.concat(response[0].body)
          })
        return results
      }
    },
    onSearchItemSelected(item) {
      if (item.plusCode) {
        this.searchQuery = item.code
      } else if (item.coordinates) {
        this.searchQuery = item.coords
      } else if (item.external_id) {
        this.searchQuery = item.name + (item.reference_location ? ' (' + item.reference_location + ')' : '')
      } else if (item.main_text) {
        this.searchQuery = item.main_text + ', ' + item.secondary_text
      } else if (item.place.formatted_address) {
        this.searchQuery = item.place.formatted_address
      }
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}

</script>
